<template>
  <component
    :is="plain ? 'div' : 'button'"
    :disabled="disabled"
    @click="emitClicked()"
    :type="type"
    :class="['btn-app', 'button-primary ', colorScheme, variant]"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: 'ButtonApp',
  props: {
    type: {
      type: String,
      default: 'button',
    },
    id: {
      type: String,
      default: '',
    },
    colorScheme: {
      type: String,
      default: 'blue',
      validate(val) {
        return ['gray', 'blue', 'danger'].includes(val);
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    plain: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      validate(val) {
        return ['blank'].includes(val);
      },
    },
  },
  methods: {
    emitClicked() {
      if (!this.disabled) {
        this.$emit('clicked');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.button-primary {
  transition: opacity 0.3s;
  outline: none;
  width: 100%;
  border: 0;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: inherit;
  line-height: inherit;
  font-size: 1rem;
  cursor: pointer;
  margin-top: 20px;
}

.blue {
  color: #ffffff;
  background: var(--btn-primary);
  height: 44px;

  &:disabled {
    color: #ffffff;
    background: #d7dce9;
    cursor: default;
  }
  &:not(:disabled):hover {
    background: #256de6;
  }
}

.gray {
  background: var(--backgound-color);
  color: var(--btn-primary);
  height: 38px;

  &:disabled {
    color: #abb1cd;
    background: #f3f6fd;
    cursor: default;
  }
  &:not(:disabled):hover {
    background: var(--gray-lighten);
  }
}

.danger {
  --btn-color: var(--error-red);

  background: var(--btn-color);
  color: #fff;

  &.blank {
    color: var(--btn-color);
    background: none;
    border: none;
    padding-right: 0;
    padding-left: 0;
    width: fit-content;
  }
  &:not(:disabled):hover {
    --btn-color: #be2a2a;
  }
}

.btn-app {
  ::v-deep {
    .loader {
      font-size: 0.25em;
    }
  }
}
</style>
